import {AfterContentInit, ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import {InputBoolean} from 'ng-zorro-antd/core/util';
import {AppTableComponentToken, AppTableHeader} from "../app-table/app-table.interfaces";
import {Utils} from '@core/utils/utils';

@Component({
  selector: 'app-table-wrap',
  templateUrl: './app-table-wrap.component.html',
  styleUrls: ['./app-table-wrap.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTableWrapComponent implements OnInit, AfterContentInit {
  @Input() appTitle;
  @Input() @InputBoolean() appShowSelectColumn = true;
  @Output() change:EventEmitter<any> = new EventEmitter<any>();
  columnSearch: string ;
  tableConfigVisible = false;
  @ContentChild(AppTableComponentToken) antTableComponent!: AppTableComponentToken;
  currentTableComponent!: AppTableComponentToken ;

  tableHeaders: AppTableHeader[] = [];
  tableHeadersSource: AppTableHeader[] = [];
  copyHeader: AppTableHeader[] = [];
  allTableFieldChecked = false;
  allTableFieldIndeterminate = false;
  detectChange: boolean = false;
  constructor() { }

  ngOnInit(): void {}

  configTableHeader() {
    this.copyHeader.length = 0;
    this.tableHeaders.forEach(item => {
      this.copyHeader.push({...item});
    })
    this.tableHeadersSource = [...this.tableHeaders];
  }

  dropTableConfig(event: any) {
    moveItemInArray(this.tableHeaders, event.previousIndex, event.currentIndex);
    this.changeTableConfigShow();
  }

  changeTableConfigShow(): void {
    const tempArray = [...this.tableHeaders];
    const fixedLeftArray: AppTableHeader[] = [];
    const fixedRightArray: AppTableHeader[] = [];
    const noFixedArray: AppTableHeader[] = [];
    tempArray.forEach(item => {
      if (item.fixed) {
        if (item.fixedDir === "left") {
          fixedLeftArray.push(item);
        } else {
          fixedRightArray.push(item)
        }
      } else {
        noFixedArray.push(item)
      }
    });
    this.currentTableComponent.tableConfig.headers = [...fixedLeftArray, ...noFixedArray, ...fixedRightArray];
    this.tableChangeDetection();
  }

  tableChangeDetection() {
    this.currentTableComponent.tableChangeDetection();
    this.detectChange = !this.detectChange;
    this.change.emit(this.detectChange)
  }

  changeSignalCheck(e: boolean, item: AppTableHeader): void {
    item.show = e;
    this.judgeAllChecked();
    this.tableChangeDetection();
  }

  judgeAllChecked(): void {
    this.allTableFieldChecked = this.tableHeaders.every(item => item.show === true);
    const allUnChecked = this.tableHeaders.every(item => !item.show);
    this.allTableFieldIndeterminate = !this.allTableFieldChecked && !allUnChecked;
  }

  reset(): void {
    this.columnSearch = null;
    this.tableHeaders = [];
    this.copyHeader.forEach(item => {
      this.tableHeaders.push({...item});
    })
    this.tableHeadersSource = [...this.tableHeaders];
    this.currentTableComponent.tableConfig.headers = [...this.tableHeaders];
    this.tableChangeDetection();
  }

  ngAfterContentInit(): void {
    this.currentTableComponent = this.antTableComponent;

    // if (this.isNormalTable) {
      this.tableHeaders = [...this.currentTableComponent.tableConfig.headers];
      this.tableHeaders.forEach(item => {
        if (item.show === undefined) {
          item.show = true;
        }
      })
    this.configTableHeader();
    this.judgeAllChecked();
    // }
  }

  changeAllTableTableConfigShow(e: boolean): void {
    if (e) {
      this.allTableFieldChecked = e;
      this.allTableFieldIndeterminate = false;
    }
    this.tableHeaders.forEach(item => item.show = item.alwaysShow ? true : e);
    this.tableHeadersSource = [...this.tableHeaders];
    this.tableChangeDetection();
  }

  searchColumn() {
    if (!Utils.isUnKnownValue(this.columnSearch)){
      this.tableHeaders = this.tableHeadersSource.filter(item => item.title.toLowerCase().startsWith(this.columnSearch.toLowerCase()))
    }
    else
      this.tableHeaders = [...this.tableHeadersSource];
  }
}
